/* eslint-disable no-new */
import MixpanelEventClass from "common/utils/ui/mixpanel-event-class";
import ModalClass from "common/utils/ui/modal-class";
import "components/jiffy/continue-shopping-modal/continue-shopping-modal-footer/continue-shopping-modal-footer";
import "components/jiffy/continue-shopping-modal/continue-shopping-modal-awards/continue-shopping-modal-awards";
import "components/jiffy/continue-shopping-modal/continue-shopping-modal-title/continue-shopping-modal-title";
import DigitalAssetsContinueShoppingModalAssetItem from "./digital-assets-continue-shopping-modal-asset-item/digital-assets-continue-shopping-modal-asset-item";
import "./digital-assets-continue-shopping-modal.scss";

export class DigitalAssetsContinueShoppingModal extends ModalClass {
  #continueButtonEvent;

  #viewCartButtonEvent;

  #lineItem;

  constructor(
    options = {
      modalSelector: ""
    }
  ) {
    super(options);

    this.#continueButtonEvent = new MixpanelEventClass({
      eventSelector: `${options.modalSelector} .js-button-continue-shopping`,
      eventCallback: () => this.closeModal(),
      mixpanelEventOptions: {
        eventName: "product_added_modal",
        eventPayload: { action: "continue_shopping" }
      }
    });
    this.#viewCartButtonEvent = new MixpanelEventClass({
      eventSelector: `${options.modalSelector} .js-button-view-cart`,
      mixpanelEventOptions: {
        eventName: "product_added_modal",
        eventPayload: { action: "view_cart" }
      }
    });
    this.#lineItem = new DigitalAssetsContinueShoppingModalAssetItem({
      lineItemTemplateSelector: ".js-continue-shopping-modal-line-item"
    });
  }

  get lineItem() {
    return this.#lineItem;
  }

  #updateTrackingEvent(responseData, trackData, assetInfo) {
    const options = {
      order_number: responseData.order_number,
      business_line: trackData.business_line,
      free_shipping_threshold: 0,
      cart_name: "", // Add cart name in the future from responseData
      items_value: assetInfo.price,
      items_added: {
        quantity: trackData.quantity,
        sku: trackData.sku,
        digital: true,
        slug: trackData.product
      }
    };
    this.#continueButtonEvent.addOrModifyMixpanelPayload(options);
    this.#viewCartButtonEvent.addOrModifyMixpanelPayload(options);
  }

  updateAndShowModal({ assetInfo, responseData, trackData }) {
    this.lineItem.fillLineItem(assetInfo);
    this.#updateTrackingEvent(responseData, trackData, assetInfo);
    this.openModal();
  }
}

export default () =>
  new DigitalAssetsContinueShoppingModal({
    modalSelector: "#digital-assets-continue-shopping-modal"
  });
